module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-delivery"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.showPage) ? _c('div', [(_vm.orderType == 0) ? _c('div', [(_vm.isShopDelivery) ? _c('div', [_c('div', {
    staticClass: "delivery-content"
  }, [_c('h2', [_vm._v("商家自行配送，暂无配送信息 "), _c('a', {
    staticClass: "btn fr",
    attrs: {
      "href": 'tel:' + _vm.shopTel
    }
  }, [_vm._v("催单")])]), _vm._v(" "), _c('div', {
    staticClass: "tel"
  }, [_vm._v("商家电话 "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.shopTel
    }
  }, [_vm._v(_vm._s(_vm.shopTel))])])])]) : _c('div', [_c('div', {
    staticClass: "navbar col22 fixed"
  }, [_c('a', {
    class: {
      active: _vm.showStatus
    },
    attrs: {
      "id": "info"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("进程状态")]), _vm._v(" "), _c('a', {
    class: {
      active: !_vm.showStatus
    },
    attrs: {
      "id": "status"
    },
    on: {
      "click": function($event) {
        return _vm.switchInfo($event)
      }
    }
  }, [_vm._v("配送信息")])]), _vm._v(" "), (_vm.showStatus) ? _c('div', {
    staticClass: "change-box"
  }, [_c('div', {
    staticClass: "status-list"
  }, [_c('ul', _vm._l((_vm.statusList), function(item) {
    return _c('li', [_c('div', {
      staticClass: "text-box"
    }, [_c('h2', [_vm._v(_vm._s(item.progressInfo))]), _vm._v(" "), _c('div', {
      staticClass: "des"
    }, [_vm._v(_vm._s(item.handlers) + " "), _c('span', {
      staticStyle: {
        "color": "#638bbb"
      }
    }, [_vm._v(_vm._s(item.handlersTel))])]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.formatDate(item.executionTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "status-tip",
      class: {
        'transparent': _vm.statusList.length == 1
      }
    }, [_c('span')])])
  }), 0)])]) : _c('div', {
    staticClass: "change-box"
  }, [_c('ul', {
    staticClass: "order-info-box goods-list"
  }, [_c('li', [_c('div', {
    staticClass: "text-box"
  }, [_c('h2', [_vm._v("配送单号")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orderInfo.code))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-box"
  }, [_c('h2', [_vm._v("取单信息")]), _vm._v(" "), _c('p', {
    staticClass: "ellipse"
  }, [_c('span', [_vm._v("店铺:")]), _vm._v(_vm._s(_vm.orderInfo.shopName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话:")]), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.orderInfo.shopTel
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.shopTel))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("地址:")]), _vm._v(_vm._s(_vm.orderInfo.pickUpPlace))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-box"
  }, [_c('h2', [_vm._v("配送信息")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("运费:")]), _vm._v("￥" + _vm._s(_vm.orderInfo.shopDeliveryFee))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("配送员:")]), _vm._v(_vm._s(_vm.orderInfo.deliveryName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话:")]), _vm._v(_vm._s(_vm.orderInfo.deliveryTel))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("状态:")]), _vm._v(_vm._s(_vm.deliveryStatusName))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-box"
  }, [_c('h2', [_vm._v("送单信息")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("商品总价:")]), _vm._v("￥" + _vm._s(_vm.orderInfo.orderAmount))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": ".3rem"
    }
  }, [_c('span', [_vm._v("支付:")]), _vm._v(_vm._s(_vm.orderInfo.orderStatusName))]), _vm._v(" "), _vm._l((_vm.orderInfo.orderGoods), function(item) {
    return _c('div', {
      staticClass: "goodsInfo",
      staticStyle: {
        "overflow": "hidden",
        "margin-bottom": "0.3rem"
      }
    }, [_c('div', {
      staticClass: "goods-img fl",
      style: ({
        backgroundImage: 'url(' + item.pic + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "fl flexcol",
      staticStyle: {
        "margin": "0",
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "goods-name ellipse"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "goods_num",
      staticStyle: {
        "margin-top": "0.25rem"
      }
    }, [_vm._v("x" + _vm._s(item.number))])]), _vm._v(" "), _c('div', {
      staticClass: "fr flexrow"
    }, [(item.originalGdAmount != null && item.originalGdAmount != '' && item.originalGdAmount != undefined) ? _c('span', {
      staticClass: "fr pri ori_pri",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.originalGdAmount))]) : _c('span', {
      staticClass: "fr pri ori_pri",
      staticStyle: {
        "margin-right": "0"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fr pri",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v("￥" + _vm._s(item.salePrice))])])])
  }), _vm._v(" "), _c('p', [_c('span', [_vm._v("送达:")]), _vm._v(_vm._s(_vm.orderInfo.deliveryDate) + " " + _vm._s(_vm.orderInfo.deliveryTime))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("单号:")]), _vm._v(_vm._s(_vm.orderInfo.orderCode))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("来源:")]), _vm._v(_vm._s(_vm.orderInfo.sysName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("标识:")]), _vm._v(_vm._s(_vm.orderInfo.orderShortNum))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("下单:")]), _vm._v(_vm._s(_vm.orderCreateTime))])], 2)])])])])]) : _c('div', [_c('div', {
    staticClass: "status-list slef-take-status"
  }, [_c('ul', _vm._l((_vm.pickupProcess), function(item) {
    return _c('li', [_c('div', {
      staticClass: "text-box"
    }, [_c('h2', {
      staticStyle: {
        "font-size": ".26rem"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('div', {
      staticClass: "status-tip",
      class: {
        'transparent': _vm.statusList.length == 1
      }
    }, [_c('span')])])
  }), 0)])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-361905c3","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/DeliveryDetail.vue
// module id = 424
// module chunks = 7